import React from "react";
import ReactPaginate from "react-paginate";
import { Grid, TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const StandardStatsAndSearch = ({ standards, searchTerm, setSearchTerm, pageCount, handlePageChange }) => {
  return (
    <div className="mb-4 mt-2">
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            placeholder="Search standards and requirements..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                bgcolor: "white",
                borderRadius: "12px",
              },
            }}
          />
        </Grid>
        <Grid item>
          <ReactPaginate
            previousLabel={"←"}
            nextLabel={"→"}
            pageCount={pageCount}
            onPageChange={handlePageChange}
            containerClassName={"pagination flex space-x-2 mt-2"}
            activeClassName={"bg-blue-500 text-white"}
            pageClassName={"px-3 py-1 border rounded-md cursor-pointer"}
            previousClassName={"px-2 py-1 border rounded-md"}
            nextClassName={"px-2 py-1 border rounded-md"}
            disabledClassName={"opacity-50 cursor-not-allowed"}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default StandardStatsAndSearch;
